<template>
  <div class="container my-5" v-if="total>limit">
    <nav>
      <ul class="pagination justify-content-center flex-wrap">
        <li class="page-item" :class="{ 'disabled': offset===0 }">
        <a class="page-link" href="#" @click.prevent="changePage(0)" tabindex="-1" :aria-disabled="offset===0">«</a>
        </li>
        <li class="page-item" :class="{ 'disabled': offset===0 }">
          <a class="page-link" href="#" @click.prevent="changePage(offset-limit)" tabindex="-1" :aria-disabled="offset===0">‹</a>
        </li>
        <li v-for="page in pagination"  v-bind:key="page.offset" class="page-item" :class="{ 'active': page.active }">
          <a class="page-link" href="#" @click.prevent="changePage(page.offset)">{{ page.label }}</a>
        </li>
        <li class="page-item" :class="{ 'disabled': offset+limit>=total }">
          <a class="page-link" href="#" @click.prevent="changePage(offset+limit)" >›</a>
        </li>
        <li class="page-item" :class="{ 'disabled': offset+limit>=total }">
          <a class="page-link" href="#" @click.prevent="changePage(lastOffset)" >»</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    total: { required: true },
    limit: { required: true },
    offset: { required: true}
  },
  mounted() {
    this.refresh();
  },
  watch: {
    total : function() {
      this.refresh();
    },
    offset: function() {
      this.refresh();
    }
  },
  data: function() {
    return {
      pagination: [],
      lastOffset: 0
    }
  },
  methods: {
    refresh: function() {
      let mo = 0;
      let label = 1;
      this.pagination = [];
      let someActive = false;
      if(this.total > this.limit) {
        while (mo < this.total) {
          if(label>10) {
            break;
          }
          this.pagination.push(
              {
                label: label,
                offset: mo,
                active: mo === this.offset,
              });
          if(mo === this.offset) {
            someActive = true;
          }
          mo = mo + this.limit;
          label = label + 1;
        }
      }
      //solve when the actual page is not included
      if(!someActive) {
        this.pagination.push(
            {
              label: this.offset/this.limit+1,
              offset: this.offset,
              active: true
            });
      }
      this.lastOffset = (Math.ceil(this.total/this.limit)-1)*this.limit;
    },
    changePage(offset) {
      this.$emit('changePage',{
        offset: offset
      });
    }
  }
};
</script>

<style>

</style>
